var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-row",
        { staticClass: "mt" },
        [
          _c(
            "w-col",
            { attrs: { xs: "12", lg: "6" } },
            [_c("app-service-pack-advantages")],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", lg: "6" } },
            [
              _c(
                "w-transition-slide-height",
                [
                  !_vm.isEditingBillingAddress
                    ? _c("app-billing-address-card", {
                        attrs: { address: _vm.billingAddress },
                        on: {
                          edit: function ($event) {
                            _vm.editBillingAddress = true
                          },
                        },
                      })
                    : _c("app-billing-address-edit", {
                        attrs: { "cancel-button": _vm.hasBillingAddress },
                        on: {
                          update: function ($event) {
                            return _vm.onNewBillingAddress($event)
                          },
                          cancel: function ($event) {
                            _vm.editBillingAddress = false
                          },
                        },
                      }),
                ],
                1
              ),
              _c("app-service-pack-info", {
                attrs: { disabled: !_vm.hasBillingAddress },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }